// extracted by mini-css-extract-plugin
export default {"selectedRaceWrapper":"selectedRace_selectedRaceWrapper__He+Pw","selectedRaceHeader":"selectedRace_selectedRaceHeader__FmKfz"};